export enum NavigationDirection {
    FIRST = 1,
    PREVIOUS = 2,
    NEXT = 3,
    LAST = 4,
}
